import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderSale } from '../../../order-sale-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderSale = 'order_sale_products';
const GROUPS_FIELD_NAME: keyof IOrderSale['order_sale_products'][number] =
    'groups';
const KILOS_FIELD_NAME: keyof IOrderSale['order_sale_products'][number] =
    'kilos';
const GROUP_WEIGHT_FIELD_NAME: keyof IOrderSale['order_sale_products'][number] =
    'group_weight';

interface IGroupsInputProps {
    index: number;
}

export function GroupsInput({ index }: IGroupsInputProps) {
    const INPUT_NAME = `${ARRAY_NAME}.${index}.${GROUPS_FIELD_NAME}`;

    const formContext = useFormContext();

    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.groups)}
            disableGutters
            onChange={(groups) => {
                const groupWeight = formContext.getValues(
                    `${ARRAY_NAME}.${index}.${GROUP_WEIGHT_FIELD_NAME}`,
                ) as IOrderSale['order_sale_products'][number]['group_weight'];
                if (!!groupWeight) {
                    formContext.setValue(
                        `${ARRAY_NAME}.${index}.${KILOS_FIELD_NAME}`,
                        (groups ? Number(groups) : 0) * groupWeight,
                    );
                }

                calculateProductsTotal({ index });
            }}
        />
    );
}
